module.exports = {
  auth_api_client_url: "https://auth-test.api.eo-heimat.de/",
  auth_api_client_id: "IVPD8GsjT33DthoO6aIjLfjEv9mt2lSaJ5vgUkRA",
  auth_api_client_secret: "secret",

  eo_maps_client_url: "https://maps-test.api.eo-heimat.de",
  maps_api_key: "FLyGFoGY1HEbIsVFNyKMbDW1eZNL2V8e3lGVAkWA",

  poi_api_client_url: "https://poi3-test.api.eo-heimat.de/",

  kis_api_client_url: "https://kis-test.api.eo-heimat.de/",

  booking_api_client_url: "https://booking-test.api.eo-heimat.de/",

  events_api_client_url: "https://events2-test.api.eo-heimat.de/",

  news_api_client_url: "https://news-test.api.eo-heimat.de/",

  maps_api_client_url: "https://maps-test.api.eo-heimat.de/",

  file_client_url: "https://download-test.eo-heimat.de/",
  file_client_token:
    "1hG90F7eSF6HePAlq5MwJbpeZTDAZbtWVX3AG8p8rpAZVG3B5pSbdqbCQ7t9vsNQWfRabrp8C3LTdbVADH2OiMrLnZR3mgkfw7Sc5mNskCQjrlqmCNa",

  assistent_api_client_url: "https://anzeigenassistent-test.api.eo-heimat.de/",

  locations_api_client_url: "https://locations-test.api.eo-heimat.de/",

  poi_widget_api_url: "https://eo-poi-widget-test.web11.oya-media.cloud/",

  pois_widget_api_url: "https://eo-pois-widget-test.web11.oya-media.cloud/",
  pois_widget_api_url_v2:
    "https://eo-pois-widget-v2-test.web11.oya-media.cloud/",
  news_widget_api_url: "https://eo-news-widget-v2-test.web11.oya-media.cloud/",
  news_issues_widget_api_url:
    "https://eo-news-issues-widget-test.web11.oya-media.cloud/",
  events_widget_api_url: "https://eo-events-widget-test.web11.oya-media.cloud/",
  events_widget_api_url_v2:
    "https://eo-events-widget-v2-test.web11.oya-media.cloud/",
  kis_widget_api_url: "https://eo-kis-widget-test.web11.oya-media.cloud/",
  kis_defect_widget_api_url:
    "https://eo-kis-defect-widget-test.web11.oya-media.cloud/",
  last_minute_widget_api_url:
    "https://eo-last-minute-widget-test.web11.oya-media.cloud/",
  events_report_widget_api_url:
    "https://eo-events-create-widget-test.web11.oya-media.cloud/",
  news_report_widget_api_url:
    "https://eo-news-create-widget-test.web11.oya-media.cloud/",
  ad_manager_ad_zone_widget_api_url:
    "https://eo-ad-zone-widget-test.web11.oya-media.cloud/",
  prompts_api_client_url: "https://prompt-test.api.eo-heimat.de/", // "http://localhost:4000/",
  ad_manager_api_client_url: "https://admanager-test.api.eo-heimat.de/",

  form_builder_api_client_url: "https://forms-test.api.eo-heimat.de/", // "http://localhost:4200/",
  forms_widget_base_url: "https://eo-forms-widget-test.web11.oya-media.cloud/"
};
